import React, { Component } from 'react';
import styled from 'styled-components';

import NavigationHeader from "../components/navigationHeader/NavigationHeader";
import Footer from "../components/footer/Footer";
import {PageContainer} from "../components/conatiner/Container";

const Wrapper = styled.div`
  .iubenda_legal_document {
    padding-top: 160px;
    padding-left: 40px;
    padding-right: 40px;
    background: #faf8f7;
    max-width: 720px;
    min-width: 320px;
    margin: auto;
    position: relative;

    @media only screen and (max-width: 896px) {
      padding-top: 80px;
      padding-left: 0;
      padding-right: 0;
    }

    @media only screen and (max-width: 512px) {
      padding-top: 40px;
      padding-left: 0;
      padding-right: 0;
    }
  }

  .iubenda_legal_document h1 {
    font: 38px "Euclid Circular A", sans-serif;
    font-weight: 800;
    line-height: 48px;
    color: #050505;
    display: inline-block;

    @media only screen and (max-width: 768px) {
      font: 32px "Euclid Circular A", sans-serif;
      font-weight: 800;
      line-height: 40px;
    }
  }

  .iubenda_legal_document h2 {
    font: 36px "Euclid Circular A", sans-serif;
    font-weight: 800;
    line-height: 48px;
    color: #050505;
    display: inline-block;

    @media only screen and (max-width: 768px) {
      font: 28px "Euclid Circular A", sans-serif;
      font-weight: 800;
      line-height: 40px;
    }
  }

  .iubenda_legal_document p {
    font: 18px "Euclid Circular A", sans-serif;
    font-weight: 400;
    line-height: 28px;
    margin-top: 32px;
    margin-bottom: 0;
    color: #050505;

    @media only screen and (max-width: 768px) {
      font: 16px "Euclid Circular A", sans-serif;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .iubenda_legal_document li {
    font: 18px "Euclid Circular A", sans-serif;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 0;
    color: #050505;

    @media only screen and (max-width: 768px) {
      font: 16px "Euclid Circular A", sans-serif;
      font-weight: 400;
      line-height: 24px;
    }
  }
`;

class TermsOfService extends Component {
    
    // @ts-ignore
    constructor(props) {

        super(props)

        this.state = {
            error: false,
            tos: "",
        };
    }

  componentDidMount() {
    // @ts-ignore
      const url = "https://www.iubenda.com/api/terms-and-conditions/48519024/no-markup"
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => {         
            
            this.setState({
              tos: result.content,
              error: false,
            });
          },
          (error) => {
            console.log("error: " + error)
            this.setState({
              error: true,
            });
          }
        )
    }

  render() {
    // @ts-ignore
    const { tos } = this.state;
    return (
      <PageContainer>
        <NavigationHeader/>
          <Wrapper dangerouslySetInnerHTML={{__html:tos}}>           
          </Wrapper>  
          <Footer />
      </PageContainer>
      );
  }
}

export default TermsOfService;